import React from 'react';

export default function TaskHeader({
  currentUser,
  locations,
  selectedLocation,
  setSelectedLocation,
  showAllTasks,
  setShowAllTasks,
  onQuickTask,
  onNewTask
}) {
  return (
    <div style={{
      backgroundColor: 'var(--card-bg)',
      border: '1px solid var(--border)',
      color: 'var(--text)',
      padding: '12px 20px',
      borderRadius: '6px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: 'var(--info-light)',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px'
          }}>
            {'📋'}
          </div>
          <div>
            <h1 style={{ fontSize: '16px', fontWeight: 600, margin: 0, color: 'var(--text)' }}>
              Zadania
            </h1>
            <p style={{ fontSize: '11px', margin: 0, color: 'var(--text-muted)' }}>
              {currentUser?.login ? `👤 ${currentUser.login}` : 'Zarządzaj zadaniami i terminami'}
            </p>
          </div>
        </div>

        {/* Location filter + Admin toggle */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {/* Location selector */}
          <select
            value={selectedLocation || ''}
            onChange={(e) => setSelectedLocation(e.target.value || null)}
            style={{
              padding: '6px 10px',
              borderRadius: '6px',
              border: '1px solid var(--border)',
              background: 'var(--card-bg)',
              color: 'var(--text)',
              fontSize: '12px',
              cursor: 'pointer',
              minWidth: '140px'
            }}
          >
            <option value="">{'📍'} Wszystkie lokalizacje</option>
            {locations.map(loc => (
              <option key={loc.id} value={loc.id}>
                {loc.nazwa}
              </option>
            ))}
          </select>

          {/* Admin toggle - show all */}
          {currentUser?.user_type === 'admin' && (
            <label style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11px',
              cursor: 'pointer',
              background: 'var(--bg-secondary)',
              padding: '6px 10px',
              borderRadius: '4px',
              border: '1px solid var(--border)'
            }}>
              <input
                type="checkbox"
                checked={showAllTasks}
                onChange={(e) => setShowAllTasks(e.target.checked)}
                style={{ width: '14px', height: '14px' }}
              />
              Pokaż wszystkie
            </label>
          )}

          <button
            onClick={onQuickTask}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              fontSize: '12px',
              fontWeight: 600
            }}
          >
            {'⚡'} Szybkie zadanie
          </button>
          <button
            onClick={onNewTask}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              fontSize: '12px',
              fontWeight: 500
            }}
          >
            {'➕'} Nowe zadanie
          </button>
        </div>
      </div>
    </div>
  );
}
